import { createContext, useContext } from "react";

/**
 * Provides an AbortSignal that useGrpcQuery forwards to the gRPC call options.
 * When the signal is aborted, in-flight requests within the provider are
 * cancelled. Defaults to `undefined` (no abort) outside of a provider.
 */
export const QueryAbortContext = createContext<AbortSignal | undefined>(
  undefined
);

export const useQueryAbortSignal = () => useContext(QueryAbortContext);
